export class UserRoleCategoryModel {
  public userRoleCategoryCode: string;
  public description: string;
  public status: string;
  public user: string;
  public updatedDate: Date;
  public url: string;


  constructor(userRoleCategoryCode: string, description: string, status: string, user: string, updatedDate: Date, url: string) {
    this.userRoleCategoryCode = userRoleCategoryCode;
    this.description = description;
    this.status = status;
    this.user = user;
    this.updatedDate = updatedDate;
    this.url = url;
  }


}
